import { ref, onMounted } from 'vue';

export default function useUniqueId(prefix = 'field') {
  const uniqueId = ref('');

  onMounted(() => {
    uniqueId.value = `${prefix}-${Math.random().toString(36).substr(2, 9)}`;
  });

  return { uniqueId };
}
